import styled from "@emotion/styled";
import { FC, useEffect, useState } from "react";
import { Button, Grid, Box, TextField } from "@mui/material"
import { useNavigate, useLocation } from 'react-router-dom';
import SearchIcon from '@mui/icons-material/Search';
import DropDownIcon from '@mui/icons-material/ArrowDropDown';
import "./SearchFinancialRatio.css";
import SelectIndustryModal from "../selectIndustry/SelectIndustryModal";
import swal from 'sweetalert2';
import { industryDataInit } from "pages/selectIndustry/IndustryData";
import { sessionDisconnectedCheck } from "shared/sessionDisconnectedCheck";

const HeaderLabel = styled.header`
    background-color: #41DBCE;
    color: #FFFFFF;
    height: 3rem;
    font-size: 1.5rem;
    padding-top: 0.5rem;
    padding-left: 2rem;
`;

const DispGrid = styled(Grid)(({ }) => ({
    textAlign: 'center',
    fontSize: '1.1rem',
    marginTop: '1.5rem',
}));

const SearchGrid01 = styled(Grid)(({ }) => ({
    backgroundColor: '#f5f5f5',
    color: '#41DBCE;',
    textAlign: 'center',
    fontSize: '1.1rem',
    fontWeight: 'bold',
    height: '21rem',
    padding: '0.5rem',
    width: 550,
    minWidth: 400,
    lineHeight: '2rem',
    marginTop: '1.5rem',
    marginBottom: '1rem',
    marginLeft: '2rem'
}));

const SearchGrid02 = styled(Grid)(({ }) => ({
    backgroundColor: '#f5f5f5',
    color: '#41DBCE;',
    textAlign: 'center',
    fontSize: '1.1rem',
    fontWeight: 'bold',
    height: '21rem',
    padding: '0.5rem',
    width: 550,
    minWidth: 400,
    lineHeight: '2rem',
    marginTop: '1.5rem',
    marginBottom: '1rem',
    marginLeft: '2rem'
}));

const AppliedButton = styled(Button)(({ }) => ({
    backgroundColor: '#01CFBE',
    color: '#FFFFFF',
    textAlign: 'center',
    fontSize: '1.2rem',
    fontWeight: 'bold',
    height: '3.2rem',
    width: '90%',
    borderRadius: '100rem',
}));

const TextFieldBox = styled(Box)(({ }) => ({
    textAlign: 'center',
    fontSize: '1rem',
    color: '#595959',
}));

const TextFieldLabel = styled(Grid)(({ }) => ({
    backgroundColor: '#595959',
    color: '#FFFFFF',
}));

const TextFieldForm = styled(Grid)(({ }) => ({
    backgroundColor: '#FFFFFF',
}));

const DataInputForm = styled(TextField)(({ }) => ({
    '& .MuiOutlinedInput-root': {
        '& fieldset': {
            border: 'none',
        },
        '&:hover fieldset': {
            border: 'none',
        },
        '&.Mui-focused fieldset': {
            border: 'none',
        },
    },
    '& .MuiInputBase-input': {
        fontSize: `0.80rem`,
    },
    "& .MuiInputBase-input.Mui-disabled": { WebkitTextFillColor: "#000", },
}))

const ComparisonbuttonArea = styled(Box)(({ }) => ({
    backgroundColor: '#595959',
    color: '#FFFFFF',
    textAlign: 'center',
    fontSize: '1rem',
    height: '9rem',
    lineHeight: '4rem',
    marginTop: '0.5rem',
    marginBottom: '3rem'
}));

const Comparisonbutton = styled(Button)(({ }) => ({
    backgroundColor: '#F2F2F2',
    color: '#595959',
    textAlign: 'left',
    fontSize: '1.2rem',
    height: '3.2rem',
    width: '17rem',
    borderRadius: '100rem',
}));

const buttonStyle = { marginTop: '5px', marginBottom: '4px' };

const comparisonbuttonStyle = { marginTop: '25px' };

const screenId = 'U030'

const SearchFinancialRatio: FC = () => {
    const navigate = useNavigate();
    const location = useLocation()

    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])

    useEffect(() => {
        const interval = setInterval(async () => {
            // セッションの有効性確認
            if (await sessionDisconnectedCheck(screenId, "polling", "", navigate)) {
                return;
            }
        }, 30000);
        return () => clearInterval(interval);
    }, []);

    const onClickTopPage = async () => {
        if (await sessionDisconnectedCheck(screenId, "onClickTopPage", yearEdition, navigate)) {
            return
        }
        navigate("/Top");
    };

    const [isSelectIndustryOpen, setIsSelectIndustryOpen] = useState<boolean>(false)

    const [industryData, setIndustryData] = useState<any>(industryDataInit)
    const [industryData2, setIndustryData2] = useState<any>(industryDataInit)
    const [yearEdition] = useState<string>(location.state.yearEdition)
    const [bttnFlg, setBttnFlg] = useState<string>('')

    useEffect(() => {
        if (location.state.industryData != undefined && location.state.industryData2 != undefined) {
            setIndustryData(location.state.industryData)
            setIndustryData2(location.state.industryData2)
        }
    }, [location])

    const onClickDisplayFinancialRatio = async () => {
        if (await sessionDisconnectedCheck(screenId, "onClickDisplayFinancialRatio", yearEdition, navigate)) {
            return
        }
        if (!industryData.industryName && !industryData2.industryName) {
            // 業種が未選択
            swal.fire({
                text: '業種を選択してください',
                icon: 'error',
                confirmButtonText: 'OK',
                confirmButtonColor: '#01CFBE',
            });
        }
        else {
            navigate("/DisplayFinancialRatio", { state: { industryData: industryData, industryData2: industryData2, yearEdition: yearEdition } });
        }
    };

    const handleConfirm = (industryData: any) => {
        if (bttnFlg == "bttn1") {
            setIndustryData(industryData)
        }
        else if (bttnFlg == "bttn2") {
            setIndustryData2(industryData)
        }
        setIsSelectIndustryOpen(false)
    }

    const handleClear = () => {
        setIndustryData(industryDataInit)
    };

    const handleClear2 = () => {
        setIndustryData2(industryDataInit)
    };

    const handleSearchButton = (value: string) => {
        setBttnFlg(value)
        setIsSelectIndustryOpen(true)
    }

    return (
        <>
            <HeaderLabel>
                標準財務比率検索
            </HeaderLabel>
            <DispGrid>
                分類種別・業種名を指定して、「標準財務比率を表示」ボタンをクリックしてください。
            </DispGrid>
            <div>
                <Box display="flex" gap={3} alignItems="center" sx={{ justifyContent: "center", alignItems: "center" }}>
                    <SearchGrid01>
                        <span style={{ fontSize: '1.5rem', fontWeight: 'bold' }}>検索1</span>
                        <Grid marginTop={2}>
                            <AppliedButton variant="contained" color="secondary" style={buttonStyle} onClick={() => handleSearchButton("bttn1")}>検索1の分類種別・業種名を指定</AppliedButton>
                        </Grid>
                        <Grid sx={{ height: '1.5rem' }}>
                            <DropDownIcon style={{ color: '#BFBFBF', fontSize: '5rem', marginTop: '-1rem' }} />
                        </Grid>
                        <Grid size={5} className="classificationType">
                            <TextFieldBox border={1}>
                                <Grid container>
                                    <TextFieldLabel size={2}>分類種別</TextFieldLabel>
                                    <TextFieldForm size={10}>
                                        <DataInputForm placeholder="上のボタンから指定してください" fullWidth disabled variant='outlined' value={industryData.classification} size='small' />
                                    </TextFieldForm>
                                </Grid>
                            </TextFieldBox>
                        </Grid>
                        <Grid size={5} className="industryName">
                            <TextFieldBox border={1}>
                                <Grid container>
                                    <TextFieldLabel size={2}>業種名</TextFieldLabel>
                                    <TextFieldForm size={10}>
                                        <DataInputForm placeholder="上のボタンから指定してください" sx={{ fontSize: '1rem' }} fullWidth disabled variant='outlined' value={industryData.industryName} size='small' />
                                    </TextFieldForm>
                                </Grid>
                            </TextFieldBox>
                        </Grid>
                        <Grid>
                            <Button onClick={handleClear} className="clear" sx={{ fontSize: '1rem', color: '#696969', marginTop: '-1rem' }}>
                                内容をクリアする
                            </Button>
                        </Grid>
                    </SearchGrid01>
                    <SearchGrid02>
                        <span style={{ fontSize: '1.5rem', fontWeight: 'bold' }}>検索2</span>
                        <Grid marginTop={2}>
                            <AppliedButton variant="contained" color="secondary" style={buttonStyle} onClick={() => handleSearchButton("bttn2")}>検索2の分類種別・業種名を指定</AppliedButton>
                        </Grid>
                        <Grid sx={{ height: '1.5rem' }}>
                            <DropDownIcon style={{ color: '#BFBFBF', fontSize: '5rem', marginTop: '-1.1rem' }} />
                        </Grid>
                        <Grid size={5} className="classificationType">
                            <TextFieldBox border={1}>
                                <Grid container>
                                    <TextFieldLabel size={2}>分類種別</TextFieldLabel>
                                    <TextFieldForm size={10}>
                                        <DataInputForm placeholder="上のボタンから指定してください" fullWidth disabled variant='outlined' value={industryData2.classification} size='small' />
                                    </TextFieldForm>
                                </Grid>
                            </TextFieldBox>
                        </Grid>
                        <Grid size={5} className="industryName">
                            <TextFieldBox border={1}>
                                <Grid container>
                                    <TextFieldLabel size={2}>業種名</TextFieldLabel>
                                    <TextFieldForm size={10}>
                                        <DataInputForm placeholder="上のボタンから指定してください" fullWidth disabled variant='outlined' value={industryData2.industryName} size='small' />
                                    </TextFieldForm>
                                </Grid>
                            </TextFieldBox>
                        </Grid>
                        <Grid>
                            <Button onClick={handleClear2} className="clear" sx={{ fontSize: '1rem', color: '#696969', marginTop: '-1.1rem' }}>
                                内容をクリアする
                            </Button>
                        </Grid>
                    </SearchGrid02>
                </Box>
            </div>
            <ComparisonbuttonArea>
                <Comparisonbutton variant="contained" color="secondary" style={comparisonbuttonStyle} onClick={onClickDisplayFinancialRatio}><SearchIcon style={{ marginRight: '0.8rem', color: '#41DBCE', }} />&nbsp;標準財務比率を表示</Comparisonbutton>
                <div>
                    <span onClick={onClickTopPage} style={{ cursor: 'pointer' }}>
                        <img src={`${process.env.PUBLIC_URL}/Icons/returnIcon.svg`} width="13px" />&nbsp;&nbsp;戻る
                    </span>
                </div>
            </ComparisonbuttonArea>
            <SelectIndustryModal industryData={bttnFlg == "bttn1" ? industryData : industryData2} isOpen={isSelectIndustryOpen} handleCloseModal={() => setIsSelectIndustryOpen(false)} yearEdition={yearEdition} onConfirm={handleConfirm} />
        </>
    );
}

export default SearchFinancialRatio;
